module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/1m-89ad6f2b48bfc7afde0e6b0cd0c71b2c.jpg";